
export const CompanyRole = {
  CUSTOMER: 'customer',
  EMPLOYEE: 'employee',
}
